import { Risk } from './Product'

export const ProductType = {
  BOTZAPPING: 'bot_zapping',
  PAID_MARKETING: 'paid_marketing',
} as const

export type ProductState = (typeof ProductType)[keyof typeof ProductType]

export type InsightsRow = {
  product: ProductState
  threatType: Risk
  domain: string
  timestamp: number
  ip: string
  platform: string
}
